@if (routerEvents$ | async) {}
<div class="st-side-bar flex flex-column align-items-center">
  <div
    class="show-hide-toggle"
    [ngClass]="{ 'show-hide-toggle-active': isExpandedMenu() }"
  >
    <button (click)="expandMenu()">
      <em class="icon-sidebar-simple"></em>
    </button>
  </div>
  <div
    class="st-side-bar-content flex-1 flex flex-column align-items-center gap-12px"
  >
    @if (homeButton() && homeButton()!.routeUrl.length) {
      <a
        [pTooltip]="tooltipContent"
        [tooltipStyleClass]="'icon-btn-tooltip'"
        class="home-button no-underline"
        [routerLink]="homeButton()!.routeUrl"
      >
        <button
          [ngClass]="{ 'home-active': isHomeButtonActive() }"
          (click)="goToHome(homeButton()!.routeUrl)"
        >
          <em [class]="homeButton()!.iconClass"></em>
        </button>
      </a>

      <div class="sidebar-tooltip">
        <ng-template #tooltipContent>
          <div class="sidebar-tooltip-content">
            <span class="label-medium-medium">
              {{ homeButton()!.title }}
            </span>
          </div>
        </ng-template>
      </div>

      <div class="side-divider"></div>
    }
    <div
      class="inner-section flex flex-column align-items-center gap-12px flex-1"
    >
      <div
        class="navigation-section flex flex-column align-items-center gap-12px"
      >
        @for (nav of navigationList(); track $index) {
          <st-icon-button [navigationItem]="nav"></st-icon-button>
        }
      </div>
      @if (tools().length) {
        <div class="apps-section">
          <st-apps-tools-menu [tools]="tools()"></st-apps-tools-menu>
        </div>
      }
      <div
        class="profile-setting-section flex flex-column align-items-center gap-12px mt-auto"
      >
        <a
          class="profile-section cursor-pointer"
          (click)="toggleMenu($event, profileMenue)"
          [title]="profile().userName"
        >
          <img
            [ngClass]="{ activeBorder: isProfilePage() }"
            [src]="profile().profileImg"
            alt=""
          />
        </a>

        <p-menu #profileMenue [model]="dropDownItems" [popup]="true">
          <ng-template pTemplate="start">
            <div class="menu-header flex gap-spacing-xs px-spacing-xl">
              <img [src]="profile().profileImg" alt="" />
              <div
                class="flex flex-column align-items-start gap-spacing-default"
              >
                <span class="label-small-regular text-caption-color"
                  >Signed in as</span
                >
                <span class="label-large-bold text-primary-color">
                  {{
                    this.userName().length > 24
                      ? this.userName().substring(0, 24) + "..."
                      : this.userName()
                  }}
                </span>
              </div>
            </div>
            <div class="px-spacing-xl pt-spacing-xs">
              <hr class="divider-line w-full border-neutral-muted-l2-bg" />
            </div>
          </ng-template>
        </p-menu>
      </div>
    </div>
  </div>
</div>
